<template>
  <div class="withdraw-manage">
    <NoticeBar />
    <div class="agency-top">
      <img src="../../assets/images/bg_02.jpg" class="img" />
      <div class="withdraw-top">
        <div class="w-top-l"><span>{{ sumPrice }}</span><p>累计兑换</p></div>
        <div class="w-top-r"><span>{{ auditSumPrice }}兑换中</span></div>
      </div>
    </div>
    <div class="withdraw-tab">
      <van-tabs v-model="active" @click="getWithdraw">
        <van-tab title="我的兑换"></van-tab>
        <van-tab title="兑换中"></van-tab>
      </van-tabs>
    </div>
    <div class="withdraw-tab">
      <div class="w-tab-m" v-for="(item, index) in list" :key="index">
        <div class="w-tab-m-top">
          <span class="left">收款方式：{{ item.type_name }}，{{ item.phone }}</span>
          <span class="right">审核状态：{{ item.status_name }}</span>
        </div>
        <div class="w-tab-m-price">
          <span>金额：{{ item.price }}</span>
          <span>手续费：{{ item.service_price }}</span>
          <span>应得：{{ item.price-item.service_price }}</span>
        </div>
        <div class="w-tab-m-info" v-if="item.member_account">
          <span>账号：{{ item.member_account.account_no }}</span>
          <span>姓名：{{ item.member_account.name }}</span>
        </div>
      </div>
    </div>

    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  import { Tab, Tabs } from 'vant';

  export default {
    components: {
      [Tabs.name]: Tabs,
      [Tab.name]: Tab,
    },
    name: 'withdrawManage',
    data() {
      return {
        active: 0,
        sumPrice: 0.00,
        auditSumPrice: 0.00,
        list: [],
      };
    },
    created() {
      this.getWithdraw()
    },
    methods: {
      getWithdraw(name, title) {
        let status = 0
        if(name === undefined || name === 0){
          status = ''
        }
        this.$api.get('users/withdrawList', {status: status}, r=>{
          r.data.list.data.map((item, index)=>{
            if(item.member_account){
              if(item.member_account.type === 1){
                item.type_name = '微信'
              }else if(item.member_account.type === 2){
                item.type_name = '支付宝'
              }else if(item.member_account.type === 3){
                item.type_name = '银行卡'
              }
            }else{
              item.type_name = '佣金转余额'
            }
            if(item.status === 1){
              item.status_name = '已通过'
            }else{
              item.status_name = '审核中'
            }
          })
          this.list = r.data.list.data
          this.sumPrice = r.data.sum_price
          this.auditSumPrice = r.data.sudit_sum_price
        })
      }
    }
  }
</script>

<style scoped>
  .withdraw-manage .withdraw-top{
    overflow: hidden;
    position: absolute;
    top: 18%;
    left: 5%;
    width: 90%;
    color:#ffffff;
    margin-top:10px;
  }
  .withdraw-manage .withdraw-top .w-top-l{
    float: left;
  }
  .withdraw-manage .withdraw-top .w-top-l span{
    font-size: 22px;
  }
  .withdraw-manage .withdraw-top .w-top-l p{
    margin: 0;
    font-size: 12px;
    padding-top:5px;
  }
  .withdraw-manage .withdraw-top .w-top-r{
    float: right;
  }
  .withdraw-manage .withdraw-top .w-top-r span{
    float: right;
    font-size: 13px;
    margin-top: 27px;
  }
  .withdraw-manage .withdraw-tab{

  }
  .withdraw-manage .withdraw-tab .w-tab-m{
    background: #ffffff;
    border-radius: 3px;
    margin-top: 10px;
    padding:10px;
    font-size: 13px;
  }
  .withdraw-manage .withdraw-tab .w-tab-m .w-tab-m-top{
    overflow: hidden;
    border-bottom: 1px solid #F5F6F7;
    padding-bottom: 6px;
  }
  .withdraw-manage .withdraw-tab .w-tab-m .w-tab-m-top span{
    display: inline-block;
  }
  .withdraw-manage .withdraw-tab .w-tab-m .w-tab-m-price{
    margin: 8px 0;
    border-bottom: 1px solid #F5F6F7;
    padding-bottom: 6px;
  }
  .withdraw-manage .withdraw-tab .w-tab-m .w-tab-m-price span{
    display: inline-block;
    width: 32%;
  }
  .withdraw-manage .withdraw-tab .w-tab-m .w-tab-m-info span{
    width: 48%;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/withdrawManage.vue